import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-magento-dev',
  templateUrl: './hire-magento-dev.component.html',
  styleUrls: ['./hire-magento-dev.component.css']
})
export class HireMagentoDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-magento-dev/hire-magento-dev.component.ts